import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import LoadThemeComponent from '../../../base/LoadThemeComponent';
import { RootState } from '../redux/store';

function ResellerModule() {
    const { t } = useTranslation();
    const { resellerOptionsEnabled, resellerCustomers, lottery } = useSelector((state: RootState) => state.playStore);

    if (!resellerOptionsEnabled) {
        return null;
    }

    const getCustomersOptions = () =>
        resellerCustomers.map((customer, i) => {
            const phoneFormated = customer.phone ? `- ${customer.phone}` : '';

            return (
                <option key={`${i + 1}`} value={customer.id}>
                    {[customer.name, customer.last_name, phoneFormated].filter((s) => s).join(' ')}
                </option>
            );
        });

    const baseView = () => (
        <>
            <div id="reseller_part_of_play_form" className="reseller_part_of_play_form">
                <div className="col d-md-flex justify-content-sm-end justify-content-center">
                    <p className="align-self-center text-nowrap mr-3"> {t('playPicker.buyTicketsFor')} </p>
                    <select className="form-control" name="customer_id">
                        <option key={0} value="">
                            {t('playPicker.myself')}
                        </option>
                        {getCustomersOptions()}
                    </select>
                </div>
            </div>
            {lottery.resellerSystemType === 1 && (
                <div className="text-center w-100 mt-5 d-none" id="youShouldChargeCustomer">
                    <p>
                        {t('playPicker.youShouldCharge')}
                        <span id="youShouldChargeCustomerSpan" />
                    </p>
                </div>
            )}
        </>
    );

    const defaultView = () => (
        <>
            <div className="card options-card d-md-flex h-100">
                <div className="card-header">{t('playPicker.buyTicketsFor')}</div>
                <div className="card-body">
                    <div id="reseller_part_of_play_form" className="reseller_part_of_play_form">
                        <select id="reseller-module" className="form-control" name="customer_id">
                            <option key={0} value="">
                                {t('playPicker.myself')}
                            </option>
                            {getCustomersOptions()}
                        </select>
                    </div>
                </div>
            </div>
            {lottery.resellerSystemType === 1 && (
                <div className="text-center w-100 mt-5 d-none" id="youShouldChargeCustomer">
                    <p>
                        {t('playPicker.youShouldCharge')}
                        <span id="youShouldChargeCustomerSpan" />
                    </p>
                </div>
            )}
        </>
    );

    return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
}

export default ResellerModule;
